import { render } from "./ConsultationPatientQueueTab.vue?vue&type=template&id=32c6d0d4"
import script from "./ConsultationPatientQueueTab.vue?vue&type=script&lang=js"
export * from "./ConsultationPatientQueueTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__